
export function pageReady(fn) {
  if (document.readyState != 'loading'){
    fn();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    document.attachEvent('onreadystatechange', function() {
      if (document.readyState != 'loading')
        fn();
    });
  }
}

export function closest(el, selector) {
  // If the current element matches the selector, return it
  if (el.matches(selector)) {
    return el;
  }
  
  // If we've reached the top of the DOM tree, return null
  if (el.parentElement === null) {
    return null;
  }
  
  // Recursively search the parent elements until we find a match
  return closest(el.parentElement, selector);
}

export function onClick(element, handler) {

  if (typeof(element) != 'undefined' && element != null) {

    if (element.addEventListener) {
      element.addEventListener('click',function(e){
        handler(e);
     }, false);
    } else {
      element.attachEvent('onclick',function(e){
        handler(e);
     });
    }
  }
}

export function onClickDynamic(element, handler) {
  document.addEventListener('click', function (event) {
    if (event.target.matches(element)) {
      handler(event);
    }
  });
}

export function onChange(element, handler) {
  if (element.addEventListener) {
    element.addEventListener('change', (e) => handler, false);
  } else {
    element.attachEvent('onchange', (e) => handler);
  }
}

export function inViewport(elem, handler) {
    let allElements = document.querySelectorAll(elem);
    let windowHeight = window.innerHeight;
   
    function viewportChecker (event,allElements,windowHeight,handler) {
      for (let i = 0; i < allElements.length; i++) {  //  loop through the sections
        let viewportOffset = allElements[i].getBoundingClientRect();  //  returns the size of an element and its position relative to the viewport
        let top = viewportOffset.top;  //  get the offset top

        if(top < windowHeight){  //  if the top offset is less than the window height
          handler(true)
        } else{
          handler(false)
        }
      }
    }

    viewportChecker(null,allElements,windowHeight,handler);
    window.addEventListener('scroll', function(event) { 
      viewportChecker(event,allElements,windowHeight,handler);
    });
}

export default {pageReady, onClick, onChange, inViewport}